import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41f290da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-5" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "row row-cols-2 g-5" }
const _hoisted_4 = { class: "row row-cols-2 g-5" }
const _hoisted_5 = { class: "row row-cols-2 g-5" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "row row-cols-2 g-5" }
const _hoisted_8 = { class: "row row-cols-2 g-5" }
const _hoisted_9 = { class: "row row-cols-2 g-5" }
const _hoisted_10 = { class: "row row-cols-2 g-5" }
const _hoisted_11 = { class: "d-flex gap-4" }

import { ref, reactive, onMounted } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import type { FormInstance } from "element-plus";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import EventServices from "../../services/EventsServices";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import ImageUploader from "quill-image-uploader";
import BlotFormatter from "quill-blot-formatter/dist/BlotFormatter";
import { LanguageTypes } from "@/core/types/LanguageTypes";
import {
  EventShopItemTypes,
  EventShopItemOptions,
  RewardTypesOptions,
  EventShopRewardTypes,
  RewardRolesOptions,
} from "@/core/types/shop/ShopItemTypes";
import UploadImageGuid from "./UploadImageGuid.vue";
import { AccessRoles } from "@/core/types/shop/ShopEventRoles";
import Decimal from "decimal.js";
import { ConfigSiteTypesSelections } from "@/core/types/SiteTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateItem',
  props: {
    categoryData: {},
    getCategoryName: {}
  },
  emits: ["submit"],
  setup(__props: any, { expose: __expose, emit: emits }) {

const props = __props;





const isSubmitting = ref(false);
const modalRef = ref<InstanceType<typeof SimpleForm>>();
const langOptions = ref<any>([]);
const contentList = ref({});
const uploadImageRef = ref(null);
const uploadBannerRef = ref(null);
const eventOptions = ref(<any>[]);
const formData = ref<any>({
  point: 1,
  name: "",
  type: EventShopItemTypes.Product,
  category: 0,
  accessRoles: ["Client", "IB", "Sales"],
  accessSites: [0],
  description: "",
  language: "en-us",
  configuration: {
    validPeriodInDays: 0,
    rewardType: EventShopRewardTypes.Point1000,
  },
});
const hide = () => {
  modalRef.value?.hide();
};

const successHide = () => {
  formData.value = {
    point: 1,
    name: "",
    type: EventShopItemTypes.Product,
    category: 0,
    accessRoles: ["Client", "IB", "Sales"],
    accessSites: [0],
    description: "",
    language: "en-us",
    configuration: {
      validPeriodInDays: 0,
      rewardType: EventShopRewardTypes.Point1000,
    },
  };
  uploadImageRef.value.handleRemove();
  modalRef.value?.hide();
};

const ruleFormRef = ref<FormInstance>();
const rules = reactive<any>({
  name: [
    { required: true, message: "Please input item name", trigger: "blur" },
  ],
  title: [
    { required: true, message: "Please input item title", trigger: "blur" },
  ],
  eventId: [
    { required: true, message: "Please select event", trigger: "change" },
  ],
});

const accessRoles = AccessRoles;

const show = async (_eventOptions: any) => {
  eventOptions.value = _eventOptions;
  modalRef.value?.show();
};

const populateLangOptions = () => {
  const langKeys = Object.keys(contentList.value);
  langOptions.value = LanguageTypes.all.filter(
    (lang) => !langKeys.includes(lang.code)
  );
};

const submit = async () => {
  if (!ruleFormRef.value) return;
  let isValid = false;
  await ruleFormRef.value.validate(async (valid, fields) => {
    isValid = valid;
  });
  if (!isValid) return;
  try {
    isSubmitting.value = true;
    formData.value.name = formData.value.title;
    await uploadBannerRef.value?.uploadImage().then(() => {
      formData.value.configuration.bannerImages =
        uploadBannerRef.value?.imageUrls;
    });
    await uploadImageRef.value
      ?.uploadImage()
      .then(() => {
        formData.value.images = uploadImageRef.value?.imageUrls;
      })
      .then(() => {
        (formData.value.point = new Decimal(formData.value.point)
          .times(10000)
          .toNumber()),
          EventServices.createShopItem(formData.value)
            .then(() => {
              MsgPrompt.success("Item created successfully");
              emits("submit");
            })
            .then(() => {
              successHide();
            });
      });
  } catch (error) {
    console.log(error);
  }
  isSubmitting.value = false;
  emits("submit");
};

const uploadImg = async (file: any) => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await EventServices.uploadImage(formData);
  return res["url"];
};

const getModules = (index: number) => {
  return [
    {
      name: "imageUploader" + index,
      module: ImageUploader,
      options: {
        upload: (file) => {
          return uploadImg(file);
        },
      },
    },
    {
      name: "blotFormatter" + index,
      module: BlotFormatter,
    },
  ];
};
onMounted(() => {
  populateLangOptions();
});
__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: _ctx.$t('action.addItem'),
    "is-loading": isSubmitting.value,
    submit: submit,
    "before-close": hide,
    class: "w-1000px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_tabs, {
        modelValue: formData.value.type,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.type) = $event)),
        type: "card",
        class: "demo-tabs"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(EventShopItemOptions), (item, index) => {
            return (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: index,
              label: item.label,
              name: item.value,
              disabled: isSubmitting.value
            }, null, 8, ["label", "name", "disabled"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_1, [
        (formData.value.type == _unref(EventShopItemTypes).Product)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_el_form, {
                ref_key: "ruleFormRef",
                ref: ruleFormRef,
                model: formData.value,
                rules: rules,
                "label-position": "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('fields.itemTitle'),
                      prop: "title"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formData.value.title,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.title) = $event)),
                          disabled: isSubmitting.value
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('fields.points'),
                      prop: "point"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: formData.value.point,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.point) = $event)),
                          min: 1,
                          disabled: isSubmitting.value
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('fields.role'),
                      prop: "accessRoles"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox_group, {
                          modelValue: formData.value.accessRoles,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.accessRoles) = $event)),
                          disabled: isSubmitting.value
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accessRoles), (role, index) => {
                              return (_openBlock(), _createBlock(_component_el_checkbox, {
                                key: index,
                                label: role.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(role.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", null, [
                      (formData.value.type === _unref(EventShopItemTypes).Product)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: _ctx.$t('fields.category'),
                            prop: "category"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: formData.value.category,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.category) = $event)),
                                class: "w-200px",
                                disabled: isSubmitting.value
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.categoryData, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: props.getCategoryName(item.value),
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }, 8, ["label"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('fields.language'),
                        prop: "language"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: formData.value.language,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.language) = $event)),
                            class: "w-200px",
                            disabled: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(langOptions.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.code,
                                  label: item.code + '   (' + item.name + ')',
                                  value: item.code
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.code + "   (" + item.name + ")"), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('fields.eventKey'),
                        prop: "eventId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: formData.value.eventId,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.eventId) = $event)),
                            class: "w-200px",
                            disabled: isSubmitting.value
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eventOptions.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.key,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('fields.site'),
                        prop: "accessSites"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_checkbox_group, {
                            modelValue: formData.value.accessSites,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.accessSites) = $event)),
                            disabled: isSubmitting.value
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigSiteTypesSelections), (role, index) => {
                                return (_openBlock(), _createBlock(_component_el_checkbox, {
                                  key: index,
                                  label: role.value
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(role.label), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('action.uploadImage'),
                        prop: "image"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(UploadImageGuid, {
                            ref_key: "uploadImageRef",
                            ref: uploadImageRef
                          }, null, 512)
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ])
                  ]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('fields.content'),
                    prop: "description"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_unref(QuillEditor), {
                          theme: "snow",
                          content: formData.value.description,
                          "onUpdate:content": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.description) = $event)),
                          modules: getModules(1),
                          contentType: "html",
                          toolbar: "full",
                          enable: !isSubmitting.value
                        }, null, 8, ["content", "modules", "enable"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ]))
          : _createCommentVNode("", true),
        (formData.value.type != _unref(EventShopItemTypes).Product)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_el_form, {
                ref_key: "ruleFormRef",
                ref: ruleFormRef,
                model: formData.value,
                rules: rules,
                "label-position": "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('fields.rewardName'),
                      prop: "name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formData.value.name,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.name) = $event)),
                          disabled: isSubmitting.value
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('fields.rewardTitle'),
                      prop: "title"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formData.value.title,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.title) = $event)),
                          disabled: isSubmitting.value
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('fields.points'),
                      prop: "point"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: formData.value.point,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.point) = $event)),
                          min: 1,
                          disabled: isSubmitting.value
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('fields.role'),
                      prop: "accessRoles"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox_group, {
                          modelValue: formData.value.accessRoles,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.accessRoles) = $event)),
                          disabled: isSubmitting.value
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accessRoles), (role, index) => {
                              return (_openBlock(), _createBlock(_component_el_checkbox, {
                                key: index,
                                label: role.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(role.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('fields.cardPointsLevel'),
                      prop: "rewardTypes"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formData.value.configuration.rewardType,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.configuration.rewardType) = $event)),
                          class: "w-200px",
                          disabled: isSubmitting.value
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(RewardTypesOptions), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('fields.rewardRoles'),
                      prop: "type"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formData.value.type,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.type) = $event)),
                          class: "w-200px",
                          disabled: isSubmitting.value
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(RewardRolesOptions), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('fields.validDays')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input_number, {
                            modelValue: formData.value.configuration.validPeriodInDays,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.value.configuration.validPeriodInDays) = $event)),
                            disabled: isSubmitting.value
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('fields.eventKey'),
                        prop: "eventId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: formData.value.eventId,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.value.eventId) = $event)),
                            class: "w-200px",
                            disabled: isSubmitting.value
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eventOptions.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.key,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('fields.language'),
                        prop: "language"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: formData.value.language,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.value.language) = $event)),
                            class: "w-200px",
                            disabled: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(langOptions.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.code,
                                  label: item.code + '   (' + item.name + ')',
                                  value: item.code
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.code + "   (" + item.name + ")"), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('fields.sites'),
                        prop: "accessSites"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_checkbox_group, {
                            modelValue: formData.value.accessSites,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.value.accessSites) = $event)),
                            disabled: isSubmitting.value
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigSiteTypesSelections), (site, index) => {
                                return (_openBlock(), _createBlock(_component_el_checkbox, {
                                  key: index,
                                  label: site.value
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(site.label), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_el_form_item, {
                          label: _ctx.$t('action.uploadCoverImage'),
                          prop: "image"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(UploadImageGuid, {
                              ref_key: "uploadImageRef",
                              ref: uploadImageRef
                            }, null, 512)
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_form_item, {
                          label: _ctx.$t('action.uploadBannerImage'),
                          prop: "image"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(UploadImageGuid, {
                              ref_key: "uploadBannerRef",
                              ref: uploadBannerRef
                            }, null, 512)
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ])
                    ])
                  ]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('fields.content'),
                    prop: "description"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_unref(QuillEditor), {
                          theme: "snow",
                          content: formData.value.description,
                          "onUpdate:content": _cache[19] || (_cache[19] = ($event: any) => ((formData.value.description) = $event)),
                          modules: getModules(1),
                          contentType: "html",
                          toolbar: "full",
                          enable: !isSubmitting.value
                        }, null, 8, ["content", "modules", "enable"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})